import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import LandingPage from 'src/pages/Dashboard/Landing/LandingPage.page';

import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

const DashboardPage = () => {
  const pageTitle = `Dashboard`;
  useSetDocumentTitle(pageTitle);
  return (
    <ContentWrapper>
      <LandingPage />
    </ContentWrapper>
  );
};

export default DashboardPage;

// Register the routes with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.Landing(),
  element: <DashboardPage />,
  isPrivate: true,
  supportsOffline: true,
});

routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.Dashboard(),
  element: <DashboardPage />,
  isPrivate: true,
  supportsOffline: true,
});

routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.DashboardSection(':section'),
  element: <DashboardPage />,
  isPrivate: true,
});
